import { render } from "./ApiDocV3.vue?vue&type=template&id=27fcc83d"
import script from "./ApiDocV3.vue?vue&type=script&lang=js"
export * from "./ApiDocV3.vue?vue&type=script&lang=js"

import "./ApiDocV3.vue?vue&type=style&index=0&id=27fcc83d&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__